import { call, all, takeLatest } from 'redux-saga/effects';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import { IInsertAnswersPayload, IClearAnswersPayload } from './answer.actions';

function* insertAnswersAsync({
    payload: { data },
}: {
    payload: IInsertAnswersPayload;
}) {
    yield getFetchInstance().post('studentanswer/insert', data);
}

function* clearAnswersAsync({
    payload: { data },
}: {
    payload: IClearAnswersPayload;
}) {
    yield getFetchInstance().post('studentanswer/clearanswerstudent', data);
}

function* watchInsertAnswers() {
    yield takeLatest(
        createFetchSagaPattern('INSERT_ANSWERS'),
        createFetchFunction('INSERT_ANSWERS', insertAnswersAsync)
    );
}

function* watchClearAnswers() {
    yield takeLatest(
        createFetchSagaPattern('CLEAR_ANSWERS'),
        createFetchFunction('CLEAR_ANSWERS', clearAnswersAsync)
    );
}

export default function* answerSagas() {
    yield all([call(watchInsertAnswers), call(watchClearAnswers)]);
}
